export const countryNameMapping = {
  PE: 'PERU',
  MX: 'MEXICO',
  US: 'UNITED STATES',
  GT: 'GUATEMALA',
  EC: 'ECUADOR',
  EG: 'EGYPT',
  SA: 'SAUDI ARABIA',
  CO: 'COLOMBIA',
  AR: 'ARGENTINA',
  DO: 'DOMINICAN REPUBLIC',
  PL: 'POLAND',
  CL: 'CHILE',
  RO: 'ROMANIA',
  PT: 'PORTUGAL',
  ES: 'SPAIN',
  TR: 'TURKEY',
  RU: 'RUSSIA',
  IND: 'INDIA',
}

/** @typedef {'PE'|'MX'|'US'|'GT'|'EC'|'EG'|'SA'|'CO'|'AR'|'DO'|'PL'|'CL'|'RO'|'PT'|'ES'|'TR'|'RU'|'IND'} CountryCode */

/** @type {Record<CountryCode, CountryCode>} */
export const COUNTRY_CODES = Object.fromEntries(Object.keys(countryNameMapping).map(code => [code, code]))

// Map country codes to currency information
export const currencyMap = {
  MX: 'MXN (Mexican Peso)',
  SA: 'SAR (Saudi Riyal)',
  EG: 'EGP (Egyptian Pound)',
  PE: 'PEN (Peruvian Sol)',
  GT: 'GTQ (Guatemalan Quetzal)',
  EC: 'USD (US Dollar)',
  CO: 'COP (Colombian Peso)',
  AR: 'ARS (Argentine Peso)',
  DO: 'DOP (Dominican Peso)',
  PL: 'PLN (Polish Zloty)',
  CL: 'CLP (Chilean Peso)',
  RO: 'RON (Romanian Leu)',
  PT: 'EUR (Euro)',
  ES: 'EUR (Euro)',
  TR: 'TRY (Turkish Lira)',
}
